import { Col, Container, Modal, Row } from "react-bootstrap";

import { Button } from "reactstrap";
import React from "react";
import Select from "react-select";

const TransactionDetailsPopup = (props) => {
  return (
    <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    className="recharge-transaction-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title>
        <h1>Transaction Details</h1>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div style={{ marginBottom: 15 }}>
        <Modal.Body>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              Type
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {" "}
              {props.transactionDetail &&
              props.transactionDetail.rechargeType === "CALLINGCARDS"
                ? "LOCAL"
                : (props.transactionDetail &&
                    props.transactionDetail.rechargeType) ||
                  ""}
              {/* {(props.transactionDetail &&
                props.transactionDetail.rechargeType) ||
                ""} */}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              {" "}
              Product Type
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {" "}
              {(props.transactionDetail &&
                props.transactionDetail.productType) ||
                ""}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              {" "}
              Sender Number
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {props.transactionDetail &&
             
                   props.transactionDetail.senderNumber} 
              {" "}
              {/* {(props.transactionDetail &&
                props.transactionDetail.senderNumber) ||
                ""} */}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              {" "}
              Sent (
              {(props.transactionDetail &&
                props.transactionDetail.sendAmount &&
                props.transactionDetail.sendAmount.currency) ||
                ""}
              )
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {(props.transactionDetail &&
                props.transactionDetail.sendAmount &&
                props.transactionDetail.sendAmount.amount) ||
                "0"}{" "}
              {(props.transactionDetail &&
                props.transactionDetail.sendAmount &&
                props.transactionDetail.sendAmount.currency) ||
                ""}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              {" "}
              Fee (
              {(props.transactionDetail &&
                props.transactionDetail.feeAmount &&
                props.transactionDetail.feeAmount.currency) ||
                ""}
              )
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {" "}
              {(props.transactionDetail &&
                props.transactionDetail.feeAmount &&
                props.transactionDetail.feeAmount.amount) ||
                "0"}{" "}
              {(props.transactionDetail &&
                props.transactionDetail.feeAmount &&
                props.transactionDetail.feeAmount.currency) ||
                ""}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              {" "}
              Debited (
              {(props.transactionDetail &&
                props.transactionDetail.feeAmount &&
                props.transactionDetail.feeAmount.currency) ||
                ""}
              )
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {parseFloat(
                props.transactionDetail &&
                  props.transactionDetail.sendAmount &&
                  props.transactionDetail.sendAmount.amount
              ) +
                parseFloat(
                  props.transactionDetail &&
                    props.transactionDetail.feeAmount &&
                    props.transactionDetail.feeAmount.amount
                )}
              {"  "}
              {(props.transactionDetail &&
                props.transactionDetail.debitAmount &&
                props.transactionDetail.debitAmount.currency) ||
                ""}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              Receiver Number
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              
               {(props.transactionDetail &&
                props.transactionDetail.mobileNumber)} 
               {""}

            
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              Operator
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {(props.transactionDetail &&
                props.transactionDetail.operator) ||
                ""}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              Receiving
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {props.transactionDetail &&
              props.transactionDetail.receiveAmount &&
              props.transactionDetail.receiveAmount.amount === ""
                ? 0
                : (props.transactionDetail &&
                    props.transactionDetail.receiveAmount &&
                    props.transactionDetail.receiveAmount.amount) ||
                  ""}{" "}
              {(props.transactionDetail &&
                props.transactionDetail.receiveAmount &&
                props.transactionDetail.receiveAmount.currency) ||
                ""}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              C3 Ref
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {(props.transactionDetail && props.transactionDetail.c3Ref) ||
                ""}
            </Col>
          </Row>
          <Row className="modal-body-content" style={{ padding: "5px 0px" }}>
            <Col lg="5" className="label-bank-details">
              Status
            </Col>
            <Col lg="1">:</Col>
            <Col lg="6">
              {" "}
              {(props.transactionDetail && props.transactionDetail.status) ||
                ""}
            </Col>
          </Row>
        </Modal.Body>
      </div>
    </Modal.Body>
  </Modal>
    // <Modal
    //   {...props}
    //   size="md"
    //   aria-labelledby="example-custom-modal-styling-title"
    //   centered
    //   animation={true}
    //   dialogClassName="modal-90w"
    // >
    //   <Modal.Header closeButton>
    //     <Modal.Title
    //       id="example-custom-modal-styling-title"
    //       style={{ textAlign: "center" }}
    //     >
    //       Transaction Details
    //     </Modal.Title>
    //   </Modal.Header>
    //   <Modal.Body>
    //     <Container>
    //       <Row style={{ padding: "10px 0px" }}>
    //         <Col xs={12} md={12} style={{ margin: 10 }}>
    //           <div
    //             style={{
    //               color: "black",
    //               display: "flex",
    //               flexDirection: "column",
    //               paddingBottom: 30,
    //             }}
    //           >
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Type:{" "}
    //               </span>{" "}
    //               International
    //             </div>
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Sender Number:{" "}
    //               </span>{" "}
    //               91956456879
    //             </div>
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Sent (AED):{" "}
    //               </span>{" "}
    //               3.00
    //             </div>
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Fee (AED):{" "}
    //               </span>{" "}
    //               0.50
    //             </div>
    //             <div style={{ paddingBottom: 30 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Disabled (AED):{" "}
    //               </span>{" "}
    //               3.50
    //             </div>
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Receiver Number:{" "}
    //               </span>{" "}
    //               91995645499
    //             </div>
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Operator:{" "}
    //               </span>{" "}
    //               Airtel India
    //             </div>
    //             <div style={{ paddingBottom: 30 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Receiving:{" "}
    //               </span>{" "}
    //               49 INR
    //             </div>
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 c3 Ref:{" "}
    //               </span>{" "}
    //               M0B0008784969
    //             </div>
    //             <div style={{ paddingBottom: 10 }}>
    //               <span style={{ fontWeight: 700, paddingRight: 5 }}>
    //                 Status:{" "}
    //               </span>{" "}
    //               Success
    //             </div>
    //           </div>
    //         </Col>
    //       </Row>
    //     </Container>
    //   </Modal.Body>
    // </Modal>
  );
};

export default TransactionDetailsPopup;
